import { render } from "./Help-centers.vue?vue&type=template&id=0b9b98d4&scoped=true"
import script from "./Help-centers.vue?vue&type=script&lang=js"
export * from "./Help-centers.vue?vue&type=script&lang=js"

import "./Help-centers.vue?vue&type=style&index=0&id=0b9b98d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9b98d4"]])

export default __exports__